if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });
    $('.slider-menu-filter').slick({
			accessibility: true, 
			arrows: true,	
			asNavFor: '.slider-content',
			infinite: false	
		});
		$('.slider-content').slick({
			accessibility: true, 
			arrows: false,
			asNavFor: '.slider-menu-filter',
			adaptiveHeight: true,
			infinite: false	
		});
    $('.sym-slides-custom').slick({
        accessibility: true, 
        arrows: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                dots: true,
                centerMode: true,
                centerPadding: '0px',
                slidesToShow: 1
              }
            }
          ]
        
    });
    $(".gallery-main").slick({
      dots: false,
      arrows: true,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            infinite: false,
            centerMode: false,
            mobileFirst: true,
          },
        },
        {
          breakpoint: 1700,
          settings: {
            centerPadding: "400px",
          },
        },
        {
          breakpoint: 1850,
          settings: {
            centerPadding: "450px",
          },
        },
        {
          breakpoint: 1950,
          settings: {
            centerPadding: "500px",
          },
        },
        {
          breakpoint: 2000,
          settings: {
            centerPadding: "400px",
          },
        },
        {
          breakpoint: 2500,
          settings: {
            centerPadding: "400px",
          },
        },
      ],
    });

    /** function menus filter */
    	if(document.querySelector('.menus-quad')){
		let tabsMenu = document.querySelectorAll('.menus-quad__filter ul li');
		let allMenus = document.querySelectorAll('.menus-quad__container .menus-quad__menu');
		let lastClickMenu = null;
    let onlyMenu = true;

		tabsMenu.forEach((tab)=>{
			tab.addEventListener('click', ()=>{
				let menuId = tab.dataset.menu;
				if(lastClickMenu){
					lastClickMenu.classList.remove('active');
				}
				tab.classList.add('active');
				allMenus.forEach((menu)=>{
					menu.classList.toggle('hidden', menuId != menu.dataset.menu);
				})
				lastClickMenu = tab;
        

        let menuContentSpecial = document.querySelector('.menus-quad__menu[data-tag="special"]')

        if(menuContentSpecial){
          let contentFullMenu = document.querySelector('.menus-quad__menu[data-tag="full-special"]')
          if(!contentFullMenu.classList.contains('hidden') && onlyMenu){
             let cloneContent = menuContentSpecial.cloneNode(true)
             cloneContent.classList.remove('hidden')
              contentFullMenu.insertAdjacentElement('afterbegin', cloneContent)
              onlyMenu = false
          }
        }

			})
		})
    if(window.innerWidth > 641){
      tabsMenu[0].click();
    }

	}
})();